import React, { useEffect, useState } from "react";
import { Space, Table } from 'antd';
import { faTrash, faEdit, faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useSnackbar } from "notistack";
import { SettingOutlined } from "@ant-design/icons";

const DataGridProComponent = (props: any) => {
  const [columns, setColumns] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(20);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  // const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [pageSizeOptions, setPageSizeOptions] = useState<any[]>(props.pageSizeOptions ?? ['20','50','100']);
  const [total, setTotal] = useState();
  const [selectAll, setSelectAll] = useState<any>(null);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState<any[]>([]);
  const fieldId = (props.fieldId ?? 'id');
        
  const [preferences, setPreferences] = useState<any | null>(() => {
      const storedPreferences = localStorage.getItem("preferences");
      return storedPreferences ? JSON.parse(storedPreferences) : []
  });
  
  const rowSelectionConfiguration: any = props.checkboxSelection
    ? {
        onChange: (currentSelectedRowKeys: React.Key[], selectedRows: any[]) => {
          setSelectedRowKeys(currentSelectedRowKeys);

          const selectedIds = new Set(currentSelectedRowKeys);

          setRows(prev =>
            prev.map(row => ({
              ...row,
              [props.checkboxKeyField]: selectedIds.has(row[fieldId])
                // ? row[props.checkboxKeyField]
                // : false,
            }))
          );

          props.setSelectedRows?.(currentSelectedRowKeys);
        },
        selectedRowKeys,
      }
    : null;

  const editColumn = [ 
    {
      key: 'operation',
      fixed: props.directionOptions ?? 'right',
      width: 70,
      title: (props.openGridSettings==null ? null : ( 
        <Space>
          <SettingOutlined onClick={() => props.openGridSettings()} />
        </Space>
      )),
      render: (e:any) => 
          <div>
            {props.hideEdit == null || props.hideEdit == false ? <FontAwesomeIcon className="button-icon" icon={faEdit} onClick={() => props.onEditAction(e[fieldId])} /> : ''} 
            {props.hideDelete == null || props.hideDelete == false ? <FontAwesomeIcon className="button-icon" icon={faTrash} onClick={() => props.onDeleteAction(e[fieldId])} /> : ''}
            {props.showUpDownButtons == true ? 
              <>
                <FontAwesomeIcon className="button-icon" icon={faAngleUp} onClick={() => onMoveColumnAction(e, fieldId)} />
                <FontAwesomeIcon className="button-icon" icon={faAngleDown} onClick={() => onMoveColumnAction(e, fieldId, true)} />
              </> : ''
            } 
          </div>
  }];

 function onMoveColumnAction(
    data: any,
    fieldId: string,
    down: boolean = false
  ) {
    setRows((prevRows) => {
      const rows = [...prevRows];

      const index = rows.findIndex(
        row => row[fieldId] === data[fieldId]
      );

      if (index === -1) return prevRows;

      const targetIndex = down ? index + 1 : index - 1;

      // limites
      if (targetIndex < 0 || targetIndex >= rows.length) {
        return prevRows;
      }

      // swap
      [rows[index], rows[targetIndex]] =
        [rows[targetIndex], rows[index]];

      return rows;
    });
  }

  useEffect(() => {
    const carregar = async () => {
      document.body.style.cursor = "progress";
      setLoading(true);
      
      try {
        await atualizaListaBusca();
      }
      catch (error) {
      // todo: show error
      }
      finally{
        document.body.style.cursor = "default";
        setLoading(false);
      }
    }

    carregar();
  }, []);

  
  useEffect(() => {
    const carregar = async () => await carregarColunas();
    carregar();

  }, [props.columns]);
  
  async function carregarColunas() {
    document.body.style.cursor = "progress";
    setLoading(true);
    
    try {
      let columns: any[] = props.columns ?? [];
      
      if (props.hideButtons == true)
      {
        setColumns(columns);
        return;
      }
      
      if (props.directionOptions == 'left')
      {
        columns = editColumn.concat(columns);
      }
      else{
        columns = columns.concat(editColumn);
      }
      
      setColumns(columns);        
    }
    catch (error) {
    // todo: show error
    }
    finally{
      document.body.style.cursor = "default";
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.responseRows?.data == null)
    {
      return;
    }

    if (props.paginationSide == 'client') {
      setRows(props.responseRows.data ?? []);
    }
    else if (props.paginationSide == 'server')
    {
      setTotal(props.responseRows.data.total);
      setPageSize(props.responseRows.data.per_page);
      setRows(props.responseRows.data.data ?? []);
    }
  }, [props.responseRows]);

  useEffect(setSelectedRowKeysEvent, [rows])

    function setSelectedRowKeysEvent()
    {
    if (props.setCurrentRows) {
      props.setCurrentRows(rows);
    }

    if (!props.checkboxSelection || !props.checkboxKeyField) return;

    const ids = rows
      .filter(r => r[props.checkboxKeyField])
      .map(r => r[fieldId]);

    setSelectedRowKeys(ids);
  }

  function getHeigth() {
    if ((props.height ?? '') == '') {
      return ((document.getElementById('main-height')?.offsetHeight ?? 0) - (props.heightFix ?? 0));
    }
    else if (parseInt(props.height)) {
      return parseInt(props.height);
    }
    else {
      return props.height;
    }
  }

  const paginationChange = (pagination: any = {}, filters: any = {}, sorter: any = {}) => {
    if (props.paginationSide == 'client')
    {
      return;
    }

    atualizaListaBusca(pagination, filters, sorter);
  }

  async function atualizaListaBusca(pagination: any = {}, filters: any = {}, sorter: any = {}) {
    atualizaListaBuscaClient();
    atualizaListaBuscaServer(pagination, filters, sorter);
  }

  async function atualizaListaBuscaClient() {
    if (props.paginationSide == 'server')
    {
      return;
    }

    try {
      setLoading(true);
      if (props.atualizaListaBuscaCallBack == null) {
        return;
      }

      await props.atualizaListaBuscaCallBack(pageSize ?? pageSizeOptions[0], 1);
    } catch (error) {
      console.log(error);
    }
    finally {
      document.body.style.cursor = "default";
      setLoading(false);
    }
  }

  async function atualizaListaBuscaServer(pagination: any = {}, filters: any = {}, sorter: any = {}) {
    if (props.paginationSide == 'client')
    {
      return;
    }

    setLoading(true);
    document.body.style.cursor = "progress";
    let pageSizeValue = pagination?.pageSize || pageSizeOptions[0];
    setPageSize(pageSizeValue);

    try {
      if (props.atualizaListaBuscaCallBack == null) {
        return;
      }
      
      await props.atualizaListaBuscaCallBack(pageSizeValue, pagination?.current ?? 1);
    }
    catch (error) {
      console.log(error);
    }
    finally {
      document.body.style.cursor = "default";
      setLoading(false);
    }
  }

  async function eventoSelecionarTodos(event: any)
  {
      enqueueSnackbar("Seleção realizadas reiniciadas após busca", {variant: 'info'});
      setSelectAll(event.target.checked);

      await props.atualizaListaBuscaCallBack(pageSize ?? pageSizeOptions[0], 1);
  }

  return (
    <div style={{ height: getHeigth(), width: '100%' }}>
        {(props.checkboxSelectionAllAdvanced??true) && props.checkboxSelection == true ? 
          <FormControlLabel
              className="col-12"
              control={
                <Checkbox
                  onDoubleClick={() => setSelectAll(null)}
                  indeterminate={selectAll == null}
                  checked={selectAll || false}
                  onChange={(e: any) => eventoSelecionarTodos(e)} />}
              label="Selecionar todos"
              labelPlacement="start" />
        : ''}
        
        <Table
          rowKey={fieldId}
          size={'small'}
          className={preferences.darkMode ? "table-dark" : ""}
          loading={loading}
          bordered={true}
          rowSelection={rowSelectionConfiguration}
          columns={columns}
          dataSource={rows}
          scroll={{ x: 'calc(700px + 50%)', y: getHeigth()-100 }}
          onChange={(e) => props.paginationSide == "client" ? {} : paginationChange(e)}
          pagination={{
            pageSize: pageSize,
            pageSizeOptions: pageSizeOptions,
            onChange(page, pageSize) {
              if (props.checkboxSelection == true)
              {
                setPageSize(pageSize);
              }
            },
            total: total
          }} />
    </div>
  )
}

export default DataGridProComponent;